import { Market } from "../../contracts";
import { CardConfiguration, MarketsBySportType } from "../../typings";
import { setSportId } from "../../helpers";

/**
 * Group markets received against cardConfiguration
 * @param markets
 * @param cardConfig
 */
export const groupMarketsBySport = (markets: Market[], cardConfig: CardConfiguration): MarketsBySportType => {
    let marketsBySport: MarketsBySportType = {};
    let sportIds: string[] = Object.keys(cardConfig);
    let currentSportId: string;
    sportIds.forEach( x=> marketsBySport[x] = []);
    markets.forEach(m => {
        currentSportId = setSportId(sportIds, m);
        marketsBySport[currentSportId].push(m);
    });
    // Object.keys(cardConfig).map(sportId => {
    //     let availableMarkets = markets.filter(m => {
    //         currentSportId = setSportId(sportIds, m);
    //         return currentSportId === sportId.toString()
    //     });

    //     marketsBySport[sportId] = availableMarkets;
    // });

    return marketsBySport;
}